import environment from '../../../../environments/environment';

export function avatarInitials(name: string) {
    if (name.toLowerCase() === name) {
        name = name.toLowerCase().split(' ').map((p) => {
            return p.charAt(0).toUpperCase() + p.slice(1);
        }).join(' ');
    }

    const parts = name.split(' ').map((p) => {
        // includes middle initials
        if (p === p.toUpperCase() && (p.length > 1 && p.charAt(1) !== '.')) {
            return [p.charAt(0)];
        }

        return p.split(/(?=[A-Z\-])/).filter((n, i, arr) => {
            // ignore suffixes and special characters
            if ('Inc.Jr.Sr.&-'.indexOf(n) > -1) {
                return false;
            }

            // ignore second-half of hyphenated name
            if (arr[i - 1] && arr[i - 1].charAt(0) === '-') {
                return false;
            }

            const initial = n.charAt(0);
            return (!isNaN(+initial) || initial === initial.toUpperCase());
        });
    });

    const flattened = parts.reduce((a, b) => a.concat(b), []);
    if (flattened.length === 0) {
        // unable to establish initials based on given name
        return '--';
    }

    return flattened[0].charAt(0) + (flattened[1] ? flattened[1].charAt(0) : '');
}

export class BaseAvatar {
    name: string;

    // profile picture for user
    userId: number;

    // path to profile picture for user
    profileImage: string;

    constructor(data: { [prop: string]: any }) {
        if (data.name) {
            this.name = data.name;
        }

        if (data.userId) {
            this.userId = data.userId;
        }

        if (data.profileImageUrl) {
            // ready-to-use URL from the API — required where the viewer can't pass the
            // tenancy gate on /users/{id}/profile-image (SD-9514: staff avatars shown
            // to customers who share no org with the staff user)
            this.profileImage = data.profileImageUrl;
        } else if (data.userId) {
            this.profileImage = `${environment.LegFiCoreApi}/users/${this.userId}/profile-image?nocache=${new Date().getTime()}`;
        }
    }

    get initials(): string {
        return avatarInitials(this.name);
    }
}
